import React from "react"
import { Navigate, useLocation } from "react-router-dom"
import { useSelector } from "react-redux"
import { isAuthenticated, isSuperAdmin } from "utils/authUtils"
import { getAuthToken, isTokenExpired } from "utils/tokenManager"
import { endSession } from "utils/endSession"
import { buildUrl } from "utils/routeUtils"
import { ROUTES } from "constants/routes"
import RouteAccessGuard from "components/RouteAccessGuard"
import { getFirstAccessibleRoute, mergeAuthContext } from "utils/accessibleRoutes"

function isSuperadminPublicAuthPath(pathname) {
  return pathname === ROUTES.SA_LOGIN
}

const Authmiddleware = ({ children }) => {
  const location = useLocation()
  const { userRole, accountType, accountScope, planSocialLogins } = useSelector(
    state => state.Login || {}
  )

  const token = getAuthToken()
  if (token && isTokenExpired(token)) {
    endSession()
    return <Navigate to={ROUTES.SESSION_EXPIRED} replace />
  }

  // Not authenticated at all → tenant login, or platform login for /superadmin/* URLs
  if (!isAuthenticated()) {
    const isPlatformEntry =
      location.pathname.startsWith("/superadmin") &&
      !isSuperadminPublicAuthPath(location.pathname)
    const loginPath = isPlatformEntry ? ROUTES.SA_LOGIN : ROUTES.LOGIN
    const to = buildUrl(loginPath, {
      redirect: location.pathname + location.search,
    })
    return <Navigate to={to} replace />
  }

  // Superadmin-only routes — send tenant users to their first allowed screen
  if (
    location.pathname.startsWith("/superadmin") &&
    !isSuperadminPublicAuthPath(location.pathname) &&
    !isSuperAdmin()
  ) {
    const target = getFirstAccessibleRoute(
      mergeAuthContext({ userRole, accountType, accountScope, planSocialLogins })
    )
    return <Navigate to={target} replace />
  }

  return (
    <RouteAccessGuard>
      <React.Fragment>{children}</React.Fragment>
    </RouteAccessGuard>
  )
}

export default Authmiddleware
